// extracted by mini-css-extract-plugin
export default {"actions":"NX9k2djl3CWRez54zvtD"};